import { derived, writable } from "svelte/store";
export const grocery_list = writable([]);
export const exclude_list = writable(new Set());
export const filtered_groceries = derived([grocery_list, exclude_list], filter);
export const flattened_groceries = derived(filtered_groceries, flatten);
export const flattened_all_groceries = derived(grocery_list, flatten);
function filter([g_list, e_list]) {
    for (var r of g_list) {
        let new_ing = r.ingredients.filter((val) => !e_list.has(`${val.name}_${val.unit}`));
        r.ingredients = new_ing;
    }
    return g_list;
}
function flatten(recipes) {
    // let ingredients = new Map<string, number>();
    let ingredients = new Map();
    for (let rec of recipes) {
        for (let ing of rec.ingredients) {
            // let arr_key: [string, string, string, string] = [
            // 	ing.name_text,
            // 	ing.unit_text,
            // 	ing.image,
            // 	ing.aisle,
            // ];
            let key = ing.aisle;
            // let key = arr_key.join(";");
            let temp = ingredients.get(key);
            if (temp) {
                temp.push(ing);
                temp = temp.sort(sort_ingredients);
                ingredients.set(key, temp);
            }
            else {
                ingredients.set(key, [ing]);
            }
        }
    }
    // let out: Map<string, Ingredient[]> = new Map();
    // for (let [key_str, amount] of ingredients.entries()) {
    // 	let [name, unit, image, aisle] = key_str.split(";");
    // 	let old = out.get(aisle);
    // 	if (old === undefined) {
    // 		old = [];
    // 	}
    // 	old.push({
    // 		amount_int: amount,
    // 		name_text: name,
    // 		unit_text: unit,
    // 		aisle: aisle,
    // 		image: image,
    // 	});
    // 	old = old.sort(sort_ingredients);
    // 	out.set(aisle, old);
    // }
    return ingredients;
}
function sort_ingredients(a, b) {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
}
